import type { Cs2EventFilterVM } from '~/composables/useRequest/cs2/data-contracts';
import type { EventTypeVM } from '~/composables/useRequest/requests/data-contracts';


const CACHE_KEY_FILTERS = 'event-settings-allEventFilters';
const CACHE_KEY_TYPES = 'event-settings-eventTypes';
const CACHE_KEY_LOADING = 'event-settings-loading';
const CACHE_KEY_PROMISE = 'event-settings-loadPromise';

/**
 * Общий кэш списков фильтров и типов событий для компонентов настроек.
 * Запросы выполняются один раз на приложение, данные переиспользуются всеми инстансами.
 */
export default function eventFilterData() {
  const { cs2EventFilter, event: eventRequest } = useRequest();

  const allEventFilters = useState<Cs2EventFilterVM[]>(CACHE_KEY_FILTERS, () => []);
  const eventTypes = useState<EventTypeVM[]>(CACHE_KEY_TYPES, () => []);
  const isLoading = useState<boolean>(CACHE_KEY_LOADING, () => false);
  const loadPromise = useState<Promise<void> | null>(CACHE_KEY_PROMISE, () => null);

  const ensureLoaded = (): Promise<void> => {
    if (loadPromise.value) {
      return loadPromise.value;
    }

    const promise = (async () => {
      try {
        isLoading.value = true;

        const [filtersData, typesData] = await Promise.all([
          cs2EventFilter.eventFilterControllerGetEventFilters(),
          eventRequest.eventTypeControllerGetEventTypeList({ limit: 500, page: 0 }),
        ]);

        allEventFilters.value = filtersData ?? [];
        eventTypes.value = typesData?.payload?.list ?? [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch event filter data:', error);
        allEventFilters.value = [];
        eventTypes.value = [];
      } finally {
        isLoading.value = false;
      }
    })();

    loadPromise.value = promise;

    return promise;
  };

  return {
    allEventFilters,
    eventTypes,
    isLoading,
    ensureLoaded,
  };
}
